<template>
  <router-view class="view" @set-background-color="setBackgroundColor" />
  <AppVersion />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import AppVersion from "./components/AppVersion.vue";

export default defineComponent({
  components: { AppVersion },
  data() {
    return {
      backgroundColor: "#ffffff",
    };
  },
  methods: {
    setBackgroundColor(background: string) {
      this.backgroundColor = background;
    },
  },
});
</script>

<style>
.view {
  min-height: 100%; /* Fallback for browsers do NOT support vh unit */
  min-height: 100vh; /* These two lines are counted as one :-)       */

  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  background-color: v-bind(backgroundColor);
}

html,
body {
  margin: 0;
  height: fit-content;
  min-height: 100vh;
  min-height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
}

::-webkit-scrollbar {
  background: transparent; /* Chrome/Safari/Webkit */
  width: 0px;
}
</style>
